import { useEffect, useState } from 'react';

// Service
import InternalVoucherService from '../../services/InternalVoucherService';

const useInternalVoucher = (internalVoucherId) => {
    const [internalVoucher, setInternalVoucher] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const SearchInternalVouchers = async () => {
            setLoading(true);
            await InternalVoucherService
                .GetByInternalVoucherId(internalVoucherId)
                .then(res => setInternalVoucher(res))
                .finally(() => setLoading(false));
        }

        if (internalVoucherId && internalVoucherId > 0)
            SearchInternalVouchers();
    }, [internalVoucherId]);

    const CreateInternalVoucher = async (entity) => 
        await InternalVoucherService.CreateInternalVoucher(entity);

    return {
        internalVoucher,
        loading,
        CreateInternalVoucher,
        setInternalVoucher
    }
}

export default useInternalVoucher;